fragment PublicTokenFragment on PublicToken {
    id
    guard
    token
    is_active
}